import React from 'react'
import { View } from 'oio-react'
import { Theme } from 'src/libraries/contexts/Theme'
import SiteName from './SiteName'

const Start = () => (
   <View
      display="flex"
      alignItems="center"
      padding="10vw 30vw"
      width="100%"
      height="100vh"
      backgroundColor="#181818">
      <Theme globalNavIsHidden />
      <SiteName />
   </View>
)

export default Start
